import { styled } from '@linaria/react';
import { colors, fonts, layout, semantic, space } from '../../theme/tokens';

export const RateCodeFieldWrapper = styled.form`
  display: flex;
  align-items: center;
  gap: ${space[3]};
  padding: ${space[4]};
  background: ${colors.white};
  border: 1px solid ${semantic.border.subtle};
  border-radius: ${layout.borderRadiusLg};
  width: 100%;

  > *:first-child {
    flex: 1;
    min-width: 0;
  }
`;

export const RateCodeClearButton = styled.button`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: ${space[5]};
  height: ${space[5]};
  border-radius: ${layout.borderRadiusFull};
  background: transparent;
  color: ${semantic.text.secondary};
  cursor: pointer;
  font-size: ${fonts.size.md};
  line-height: 1;
  padding: 0;
  border: none;
  flex-shrink: 0;

  &:hover {
    background: ${semantic.bg.surfaceSubtle};
    color: ${semantic.text.primary};
  }

  &:focus-visible {
    outline: 2px solid ${colors.primary};
    outline-offset: 2px;
  }
`;

export const RateCodeApplyButton = styled.button`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  padding: ${space[3]} ${space[5]};
  background: ${colors.primary};
  color: ${colors.white};
  border: none;
  border-radius: ${layout.borderRadiusFull};
  font-family: ${fonts.body};
  font-size: ${fonts.size.sm};
  font-weight: ${fonts.weight.semiBold};
  cursor: pointer;
  white-space: nowrap;
  transition: opacity 0.15s ease;

  &:disabled {
    opacity: 0.4;
    cursor: not-allowed;
  }

  &:focus-visible {
    outline: 2px solid ${colors.primary};
    outline-offset: 2px;
  }

  &:hover:not(:disabled) {
    opacity: 0.9;
  }
`;
